import { gql } from "graphql-request";

const SERVER_CREATE_DOCUMENT = gql`
  mutation SERVER_CreateDocument($input: DocumentInput!) {
    createDocument(input: $input) {
      id
    }
  }
`;
export default SERVER_CREATE_DOCUMENT;